/* istanbul ignore file */

import 'katex/dist/katex.min.css';
import { globalCss } from '@classtinginc/design-system';

globalCss({
  'html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video':
    {
      margin: 0,
      padding: 0,
      border: 0,
      fontSize: '100%',
      verticalAlign: 'baseline',
    },

  /* HTML5 display-role reset for older browsers */
  'article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section':
    {
      display: 'block',
    },

  'ol, ul': {
    listStyle: 'none',
  },

  'blockquote, q': {
    quotes: 'none',
  },
  'blockquote:before, blockquote:after, q:before, q:after': {
    content: 'none',
  },
  table: {
    borderCollapse: 'collapse',
    borderSpacing: 0,
  },
  a: {
    textDecoration: 'none',
    color: 'inherit',
  },
  body: {
    lineHeight: 1,
    '&.body--gray': {
      backgroundColor: '$gray-050',
    },
    '&.body--white': {
      backgroundColor: '$white',
    },
    '&.body--white-gray-gradient': {
      backgroundColor: '$white',
      '@lg': {
        background: 'linear-gradient(to right, #fff, #fff 50%, #F9F9FA 50%)',
      },
    },
    '&.assignment-submission-page': {
      '@lg': {
        overflow: 'hidden',
      },

      '#navbar, #side-nav': {
        display: 'none',
      },
    },
    '&.submission-detail-page': {
      '#navbar, #side-nav': {
        display: 'none',
      },
    },
    '&.post-detail-page': {
      '#navbar': {
        display: 'none',
      },
    },
    '&.post-editor-page': {
      '#navbar': {
        display: 'none',
      },
      '@sm': {
        '#navbar': {
          display: 'inherit',
        },
      },
    },
    '&[data-visible-post-detail-bottom-banner="true"]': {
      '#post-detail-layout-body': {
        paddingBottom: '3.5rem',
      },
    },
    '#app-bar-bottom': {
      display: 'none',
    },

    '--global-bottom-padding': '0rem',
    '&[data-visible-app-bar-bottom="true"][data-is-inapp=""]': {
      '#app-bar-bottom': {
        display: 'block',
        '@xl': {
          display: 'none',
        },
      },
      '--global-bottom-padding': '5.125rem',
      paddingBottom: '5.125rem',
      '@xl': {
        '--global-bottom-padding': '0rem',
        paddingBottom: 0,
      },

      '#main-post-list-page-floating-button': {
        bottom: '$layout-08',
      },
    },
    '&[data-is-inapp="true"][data-visible-app-bar-bottom-inapp="true"]': {
      '#app-bar-bottom': {
        display: 'block',
      },
      '#main-post-list-page-floating-button': {
        bottom: '$layout-08',
      },
      '#main-post-list-page': {
        paddingBottom: '5.125rem',
      },
    },
    '&.full-screen': {
      '#navbar': {
        display: 'none',
      },
    },
    fontFamily: '$noto',
    'html[lang="zh-HK"] &': {
      fontFamily: "'Noto Sans HK', sans-serif",
    },
    height: '100%',
    wordBreak: 'keep-all',
    wordWrap: 'break-word',
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
  },
  'button, input, optgroup, select, textarea': {
    fontFamily: 'inherit',
    fontSize: 'inherit',
    lineHeight: 'inherit',
  },

  // FIXME inspx padding component에 대한 hotfix
  padding: {
    boxSizing: 'border-box',
  },

  'input[type="number"]': {
    appearance: 'textfield',
  },
  'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: '0',
  },

  'input[type=search]': {
    backgroundColor: 'inherit',
  },
  'input[type="search"]::-webkit-search-decoration, input[type="search"]::-webkit-search-cancel-button, input[type="search"]::-webkit-search-results-button, input[type="search"]::-webkit-search-results-decoration':
    {
      display: 'none',
    },

  '.Tiptap-mathematics-editor': {
    background: '#202020',
    color: '#fff',
    'font-family': 'monospace',
    padding: '0.2rem 0.5rem',
  },

  '.Tiptap-mathematics-render': {
    margin: '0.5rem 0',
    padding: '0 0.25rem',

    '&--editable': {
      cursor: 'pointer',
      transition: 'background 0.2s',

      '&:hover': {
        background: '#eee',
      },
    },

    '.katex': {
      display: 'inline-block',
      'text-align': 'left',
    },
  },

  '.Tiptap-mathematics-editor, .Tiptap-mathematics-render': {
    'border-radius': '0.25rem',
    display: 'inline-block',
  },
})();
